<template>
    <cp-video-input v-bind="$attrs" :value="valueForInput" @input="handleChange" />
</template>

<script>
    import CpVideoInput from './video-file';
    window.CpVideoInput = CpVideoInput;

    export default {
        components: {
            CpVideoInput,
        },

        props: {
            value: Object,
        },

        computed: {
            valueForInput() {
                return this.apiValueToInputValue(this.value);
            },
        },

        methods: {
            hasCoordinateSettings(apiValue) {
                return apiValue.settings && ['x', 'y', 'width', 'height'].every(apiValue.settings.hasOwnProperty, apiValue.settings);
            },

            apiValueToInputValue(apiValue) {
                const inputValue = CpVideoInput.methods.makeEmptyValue();
                if (apiValue) {
                    if (this.hasCoordinateSettings(apiValue)) {
                        let {x, y, width, height} = apiValue.settings;
                        [x, y, width, height] = [x, y, width, height].map(parseFloat);
                        Object.assign(inputValue, {x, y, width, height});
                    }

                    let version = 1;
                    if ('settings' in apiValue && 'version' in apiValue.settings) {
                        version = apiValue.settings.version;
                    }

                    if ('video' in apiValue) {
                        // TODO: Where'd this come from, is there ever an `image` property?
                        inputValue.video = apiValue.video;
                        inputValue.name = apiValue.name;
                    } else if ('id' in apiValue) {
                        // Prefer the ID over the URL, which probably includes translations.
                        inputValue.video = `https://res.cloudinary.com/crowdpac/video/upload/v${version}/${apiValue.id}`;
                    } else if ('url' in apiValue) {
                        // TODO: Is there ever a `url`` without an `id`?
                        inputValue.video = apiValue.url;
                    }
                }
                return inputValue;
            },

            inputValueToApiValue(inputValue) {
                if (inputValue.video === null) {
                    return null;
                } else {
                    // Build on a clone of the original values, we'll write changes on top to avoid losing any extra data.
                    const apiValue = Object.assign({}, this.value);
                    apiValue.settings = Object.assign({}, apiValue.settings);

                    if (inputValue.video.indexOf('cloudinary.com/') !== -1) {
                        // The server already knows about this.
                        if (this.value) apiValue.id = this.value.id;
                        if (this.value) apiValue.url = this.value.url;
                    } else {
                        // This will have to be re-uploaded.
                        apiValue.video = inputValue.video;
                        apiValue.name = inputValue.name;
                        apiValue.size, inputValue.size;
                    }

                    const {x, y, width, height} = inputValue;
                    Object.assign(apiValue.settings, {x, y, width, height});                    

                    return apiValue;
                }
            },

            handleChange(inputValue) {
                const apiValue = this.inputValueToApiValue(inputValue);
                this.$emit('input', apiValue);
            },
        },
    };
</script>
